import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { DataField } from '@/components/flyouts/types';
import { isAdvisorUserRole } from '@/constants/roles';
import { useLocalization } from '@/hooks/useLocalization';
import type { AccountBase } from '@/models/AccountViewModel';
import type { WARootState } from '@/store/store';
import AccountHeldBy from '../components/AccountHeldBy';
import { linkableAccountInvestors } from '../utils/accountInvestors';

export const useAdvisorAccountFields = (account: AccountBase): DataField[] => {
  const { t } = useLocalization();
  const isAdvisor = isAdvisorUserRole(
    useSelector((state: WARootState) => state.auth.currentRole),
  );

  return useMemo(() => {
    if (!isAdvisor) return [];

    const fields: DataField[] = [
      {
        title: t('AUM'),
        value: account.IsHome ? t('AUM') : t('HeldAway'),
      },
    ];

    const owners = linkableAccountInvestors(account.Investors);
    if (owners.length > 0) {
      fields.push({
        title: t('grid.heldBy'),
        value: <AccountHeldBy investors={owners} />,
      });
    }

    return fields;
  }, [isAdvisor, account.IsHome, account.Investors, t]);
};
